import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

/**
 * Component displayed after an athlete successfully accepts an invitation
 */
const InviteAcceptedSuccess = ({ athlete, organization, organization_details }) => {
    // Use organization_details if available, otherwise fallback to string
    const orgDetails = organization_details || {};
    const orgName = orgDetails.name || organization || '';
    const logoUrl = orgDetails.logo_url || null;
    
    // Format athlete name
    const athleteName = athlete && (athlete.full_name || 
        `${athlete.first_name || ''} ${athlete.last_name || ''}`.trim());
        
    return (
        <div className={styles.container}>
            <div className={styles.card}>
                {logoUrl && (
                    <div className={styles.logoContainer}>
                        <img src={logoUrl} alt="Organization logo" className={styles.logo} />
                    </div>
                )}
                
                <div className={styles.successIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="64" height="64">
                        <circle cx="12" cy="12" r="10" fill="#4CAF50" />
                        <path d="M9.5 16.5l-4-4 1.4-1.4 2.6 2.6 7.6-7.6 1.4 1.4-9 9z" fill="white" />
                    </svg>
                </div>
                
                <h2>Invitation Accepted!</h2>
                
                <div className={styles.successMessage}>
                    <p>
                        You've successfully claimed your athlete profile
                        {athleteName ? ` for ${athleteName}` : ''}
                        {orgName ? ` at ${orgName}` : ''}.
                    </p>
                    
                    <h3>What's Next?</h3>
                    
                    <p>Your coach will assign workouts and track your progress through the RepOne platform.</p>
                    
                    <div className={styles.appSection}>
                        <h3>Get the RepOne App</h3>
                        <p>Download the RepOne Athlete app to access your workouts on your mobile device:</p>
                        
                        <div className={styles.appButtons}>
                            <a
                                href="https://apps.apple.com/us/app/repone-athlete/id1608123039"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.storeButton}
                            >
                                <div className={styles.appleButton}>
                                    <span className={styles.storeText}>
                                        <span className={styles.smallText}>Download on the</span>
                                        <span className={styles.largeText}>App Store</span>
                                    </span>
                                </div>
                            </a>
                        </div>

                        <div className={styles.comingSoonMessage}>
                            <p>Android app coming soon!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InviteAcceptedSuccess; 